import React, { useContext } from "react";
import styles from "./styles.module.scss";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CartList from "../../CartList/cartList";
import AppContext from "@/modules/storefront/hooks/appContext";
import CartFooter from "../../CartFooter/cartFooter";
import ShippingForm from "../../ShippingForm/shippingForm";
import OrderPage from "../../OrderPage/orderPage";

const CartModalMobile = (props) => {
  const {
    cart,
    cartPage,
    changeCartPage,
    hideCartModal,
  } = useContext(AppContext);

  const closeCart = () => {
    changeCartPage("cart");
    hideCartModal();
  }

  const navigateToShipping = () => {
    if (cart.length > 0) changeCartPage("shipping");
  }

  const propsRenderShowClasses = `${styles['cart-modal']} ${styles['display-block']}`;
  const propsRenderHideClasses = `${styles['cart-modal']} ${styles['display-none']}`;
  const showHideClassName = props.show ? propsRenderShowClasses : propsRenderHideClasses;

  const propsRenderShowModalName = `${styles['cart-modal-main']} ${styles.open}`;
  const propsRenderHideModalName = `${styles['cart-modal']} ${styles.close}`;
  const showHideModalName = props.show ? propsRenderShowModalName : propsRenderHideModalName;

  const cartLinkClasses = `${styles['header-item']} ${cartPage === "cart" ? styles.active : ""}`
  const shippingLinkClasses = `${styles['header-item']} ${cartPage === "shipping" ? styles.active : ""}`

  return (
    <>
      <div className={showHideClassName}>
        <section className={showHideModalName}>
          <div className={styles['modal-header']}>
            <div className={styles['cart-shipping']}>
              <div className={cartLinkClasses} onClick={() => changeCartPage("cart")}>Cart</div>
              <div className={styles['header-item']}><NavigateNextIcon /></div>
              <div className={shippingLinkClasses} onClick={navigateToShipping}>Shipping</div>
            </div>

            <div className={styles['modal-close']} onClick={closeCart}>
              <div className={styles['header-item']}>&larr; Back to shop</div>
            </div>
          </div>

          <div 
            className={ `
              ${styles['modal-body']} 
              ${cartPage === "cart" ? styles.cartScreen : ''} 
              ${cartPage === "shipping" ? styles.shippingScreen : ''} 
              ${cartPage === "order" ? styles.orderScreen : ''}
              ` }>
            {cartPage === "cart" && <CartList />}

            {
              cartPage === "shipping" &&
              <ShippingForm
                createOrder={props.handleCreateOrder}
              />
            }

            {
              cartPage === "order" &&
              <OrderPage
                createOrder = {props.handleCreateOrder}
                isLoadingModal={props.isLoadingModal}
              />
            }
          </div>

        </section>
      </div>
    </>
  )
}

export default CartModalMobile;
